import { useCallback, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setUserMsg } from '../../store/user'
import { RootState } from '../../store/configure-store'
import { UserMessage } from './user-message'

export const UserMsg = () => {
    const dispatch = useDispatch()
    const userMsg = useSelector((storeState: RootState) => storeState.users.msg)
    const timeoutId = useRef<NodeJS.Timeout>()

    const onCloseMsg = useCallback(() => {
        clearTimeout(timeoutId.current)
        dispatch(setUserMsg({ msg: null }))
    }, [dispatch])

    useEffect(() => {
        if (timeoutId.current) clearTimeout(timeoutId.current)

        timeoutId.current = setTimeout(() => {
            onCloseMsg()
        }, 5000)

        return () => {
            clearTimeout(timeoutId.current)
        }
    }, [userMsg, onCloseMsg])

    if (!userMsg) return <section className="user-msg"></section>

    return <UserMessage type={userMsg.type} onClose={onCloseMsg}>{userMsg.txt}</UserMessage>
}
